var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)

function Post(el) {
	this.el = el;
	this.$el = $(el);
	
	//Change Sub Nav to select menu at mobile
	$(".post__sub-nav a").each(function() {
 		var el = $(this);
		 	$("<option />", {
		     "value"   : el.attr("href"),
		     "text"    : el.text()
		 	}).appendTo(".post__sub-nav select");
	});
	
	$('.sub-heading').each(function() {
		$(this).html('<span>'+ $(this).html() +'</span>');
	});

	$(".post__sub-nav select").change(function() {
  	window.location = $(this).find("option:selected").val();
	});

	$(".post__sub-nav option").each(function () {
    if ($(this).val() === window.location.toString()) {
        $(this).prop('selected', true);
    }
	});

	$('.post__sidebar a').each(function () {
		var href = this.href,
			hrefLength = href.length,
			currentHref = window.location.href,
			currentHrefLength = currentHref.length;

		if (hrefLength && href.charAt(currentHrefLength) === '#') {
			var destination = $(href.substring(currentHrefLength, hrefLength));
			if (destination) {
				$(this).click(function () {
					destination.focus();
				})
			}
		}
	});
}

module.exports = Post;
